var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    rx: 5,
    fill: "#1B1C28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1284_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9587 11.7917L14.792 5.41669C15.3556 5.41669 15.8961 5.64057 16.2946 6.03909C16.6931 6.4376 16.917 6.9781 16.917 7.54169V10.375H20.9262C21.1315 10.3727 21.3349 10.415 21.5223 10.4991C21.7096 10.5832 21.8765 10.707 22.0112 10.862C22.146 11.017 22.2454 11.1994 22.3027 11.3966C22.3599 11.5938 22.3736 11.8011 22.3428 12.0042L21.3653 18.3792C21.3141 18.717 21.1425 19.0249 20.8822 19.2462C20.6218 19.4675 20.2903 19.5872 19.9487 19.5834H11.9587M11.9587 11.7917V19.5834M11.9587 11.7917H9.83366C9.45794 11.7917 9.0976 11.9409 8.83192 12.2066C8.56625 12.4723 8.41699 12.8326 8.41699 13.2084V18.1667C8.41699 18.5424 8.56625 18.9027 8.83192 19.1684C9.0976 19.4341 9.45794 19.5834 9.83366 19.5834H11.9587",
    stroke: "#2488FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1284_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/LikeIcon.b6b9eb4ce86627d377a52da02fb2a3f2.svg";
export { ForwardRef as ReactComponent };